/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCell,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {RoomModel} from '../../../room/models'
import Swal from 'sweetalert2'
import {deleteRoomService} from '../../../room/services/deleteRoom.service'
import {enqueueSnackbar} from 'notistack'
import {getRoomsService} from '../../../room/services/getRooms.service'
import {Column} from 'react-table'
import {ModelNewRoom} from '../Modal/ModalNewRoom'
import {ModalUpdateRoom} from '../Modal/ModalUpdateRoom'
import {getSnackBarToast} from '../../../../../../util/snackBar'

const TableRooms: FC = () => {
  const {data, setData, setPagination, loading, setLoading, selected, pagination} = useKTable()
  const {currentTabItem, isAllowed} = useHoteleria()
  const [showModalUpdate, setShowModalUpdate] = useState(false)
  const [showModalNew, setShowModalNew] = useState(false)
  const [roomToEdit, setRoomToEdit] = useState<RoomModel | any>(null)

  const handleNew = () => {
    setShowModalNew(true)
  }

  const getSnackBar = (message: string, variant: boolean) => {
    enqueueSnackbar(message, {
      variant: variant ? 'success' : 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    })
  }

  const getRooms = async () => {
    setLoading(true)
    const {data: response} = await getRoomsService({
      ModuloId: currentTabItem.idToEdit,
      pageNumber: pagination.currentPage,
      size: pagination.perPage,
    })
    if (!response.error) {
      setData(response.data)
      setPagination({
        ...pagination,
        totalResults: response.total,
      })
    }
    setLoading(false)
  }

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        const mappedSelected = selected.map((item) => ({Id: item}))
        const {data: response} = await deleteRoomService(mappedSelected)
        if (!response.error) {
          getSnackBarToast('Se eliminó satisfactoriamente', 'success')
          //   getBathRooms()
        } else {
          getSnackBarToast(response.message, 'error')
        }
        getRooms()
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleEdit = (item: RoomModel) => {
    setRoomToEdit(item)
    setShowModalUpdate(true)
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    getRooms()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    getRooms()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const columns: Column<RoomModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCell id={props.data[props.row.index].Id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nomenclatura de Módulo' />,
      accessor: 'Modulo_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Habitación' />,
      accessor: 'TipoHabitacion_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nomenclatura de Habitación' />,
      accessor: 'Codigo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de baño' />,
      accessor: 'TipoBanio_descripcion',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('HABITACION/EDITAR') && (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEdit(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          )}
        </>
      ),
    },
  ]

  return (
    <>
      {isAllowed('HABITACION/LISTAR') && (
        <KTCard shadow className='m-5'>
          <div className='d-flex justify-content-end p-2 me-5'>
            {isAllowed('HABITACION/AGREGAR') && (
              <button type='button' className='btn btn-success me-3' onClick={handleNew}>
                Agregar
              </button>
            )}
            {isAllowed('HABITACION/ELIMINAR') && (
              <button
                className='btn btn-primary me-3'
                disabled={selected.length < 1}
                onClick={handleDelete}
                type='button'
              >
                Eliminar
              </button>
            )}
          </div>
          <KTable data={data} columns={columns} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
          {showModalUpdate ? (
            <ModalUpdateRoom
              show={showModalUpdate}
              setShow={setShowModalUpdate}
              roomToEdit={roomToEdit}
              getRooms={getRooms}
            />
          ) : (
            <></>
          )}
          {showModalNew ? (
            <ModelNewRoom show={showModalNew} setShow={setShowModalNew} getRooms={getRooms} />
          ) : (
            <></>
          )}
        </KTCard>
      )}
    </>
  )
}

const TableRoomsFromRoomWrapper = () => {
  return (
    <KTableProvider>
      <TableRooms />
    </KTableProvider>
  )
}

export {TableRoomsFromRoomWrapper}
